import { Catalog } from 'react-planner';
import * as Areas from './areas/index';
import * as Lines from './lines/index';
import * as Holes from './holes/index';
import * as Items from './items/index';
import * as Annotations from './annotations/index';
import * as Pipes from './pipes/index';
import * as Fittings from './fittings/index';
import Translate from "../common/functions/translate";

export function GetCatalog() {
  let catalog = new Catalog();
  let others = [];

  for (let x in Lines) {
    Lines[x].info.title = Translate(Lines[x].info.title);
    Lines[x].info.description = Translate(Lines[x].info.description);
    catalog.registerElement(Lines[x]);
  }

  for (let x in Areas) {
    Areas[x].info.title = Translate(Areas[x].info.title);
    Areas[x].info.description = Translate(Areas[x].info.description);
    catalog.registerElement(Areas[x]);
  }

  for (let x in Holes) {
    Holes[x].info.title = Translate(Holes[x].info.title);
    Holes[x].info.description = Translate(Holes[x].info.description);
    catalog.registerElement(Holes[x]);
  }

  for (let x in Annotations) {
    Annotations[x].info.title = Translate(Annotations[x].info.title);
    Annotations[x].info.description = Translate(Annotations[x].info.description);
    catalog.registerElement(Annotations[x]);
  }

  for (let x in Pipes) {
    Pipes[x].info.title = Translate(Pipes[x].info.title);
    Pipes[x].info.description = Translate(Pipes[x].info.description);
    catalog.registerElement(Pipes[x]);
    others.push(Pipes[x]);
  }

  for (let x in Items) {
    Items[x].info.title = Translate(Items[x].info.title);
    Items[x].info.description = Translate(Items[x].info.description);
    catalog.registerElement(Items[x]);
    if (Items[x].name !== 'simple-stair' && Items[x].name !== 'circular-stairs' &&
      Items[x].name !== 'void' && Items[x].name !== 'void-circle' &&
      Items[x].name !== 'round column' && Items[x].name !== 'square column')
      others.push(Items[x]);
  }

  for (let x in Fittings) {
    catalog.registerElement(Fittings[x]);
  }

  catalog.registerCategory('windows', Translate('Windows'), [Holes.Window, Holes.SashWindow, Holes.VenetianBlindWindow, Holes.WindowCurtain], false);
  catalog.registerCategory('doors', Translate('Doors'), [Holes.Door, Holes.DoorDouble, Holes.Gate, Holes.PanicDoor, Holes.PanicDoorDouble, Holes.SlidingDoor], false);
  catalog.registerCategory('annotations', Translate('Annotations'), [Annotations.Text, Annotations.Label, Annotations.NorthSign, Annotations.ElevationSign,
  Annotations.CirclePointer, Annotations.ChimneySign], false);
  catalog.registerCategory('hidden', 'Hidden', others, true);
  catalog.registerCategory('fittings', 'Fittings', [Fittings.MagnetVentil, Fittings.TransitionalHolender, Fittings.Coupling, Fittings.Nipel,
  Fittings.Triple, Fittings.Ventil, Fittings.Elbow], true);

  return catalog;
}

